import React from 'react'
import css from './ErrorOerlay.module.css'

type ErrorOerlayProps = {
  error: string | null
}

const ErrorOerlay: React.FC<ErrorOerlayProps> = ({ error }) => {
  return (
    <div className={css.overlay}>
      <div className={css.overlay__content}>
        {error ? (
          <div className={css.error__message}>
            {error}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ErrorOerlay